import { render, staticRenderFns } from "./relationProList.vue?vue&type=template&id=4b487c87"
import script from "./relationProList.vue?vue&type=script&lang=js"
export * from "./relationProList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports